import RestService from "./rest.service";


class ReportService {
  listCategory() {
    return new Promise(async (fnResolve, fnReject) => {
      RestService.get("app/admin/report/category").then(
        (response) => {
          localStorage.setItem("date", response.data.expire);
          if (response.data.success) {
            fnResolve(response.data)
            return;
          }
          fnReject(response)
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listReport(category = null) {
    return new Promise(async (fnResolve, fnReject) => {
      let url = 'app/admin/report/list'
      if (category) url += '/' + category

      RestService.get(url).then(
        (response) => {
          localStorage.setItem("date", response.data.expire);
          if (response.data.success) {
            fnResolve(response.data)
            return;
          }
          fnReject(response)
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getReport(id) {
    return new Promise(async (fnResolve, fnReject) => {
      RestService.get("app/admin/report/" + id).then(
        (response) => {
          localStorage.setItem("date", response.data.expire);
          if (response.data.success) {
            fnResolve(response.data)
            return;
          }
          fnReject(response)
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  queryReportData(report_id, filter = {}) {
    return new Promise(async (fnResolve, fnReject) => {
      RestService.post("app/admin/report/filter/" + report_id, filter).then(
        (response) => {
          localStorage.setItem("date", response.data.expire);
          if (response.data.success) {
            fnResolve(response.data)
            return;
          }
          fnReject(response)
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new ReportService();
